module.exports = __webpack_public_path__ + "static/media/CreateOptimized.5eb3f7e0.webp";